<ion-nav [class]="env">
  <ion-router-outlet></ion-router-outlet>
</ion-nav>
